export default "__VITE_ASSET__5b5c0b8b__"